<template>
  <div class="contentHome">
    <div class="centerPage ">
      <div class="login">
        <div class="leftBG">
          <strong>欢迎使用</strong>
          <h1>心理亦笙</h1>
          <div class="content">
            <span><i class="el-icon-check"></i>资深医生</span>
            <span><i class="el-icon-check"></i>线上咨询</span>
            <span><i class="el-icon-check"></i>心理测试</span>
            <span><i class="el-icon-check"></i>公益科普</span>
            <span><i class="el-icon-check"></i>地区资源</span>
          </div>
        </div>
        <el-form ref="userForm" :model="user" @keyup.enter.native="onSubmit" v-loading="autoLoginLoading"
                 element-loading-text="自动登录中...">
          <h2 class="title">用户登录</h2>
          <div class="elInput">
            <el-input type="tel" v-model="user.account" placeholder="手机号/邮箱/用户名"></el-input>
          </div>
          <div class="elInput">
            <el-input type="password" v-model="user.pwd" placeholder="密码"></el-input>
          </div>
          <div class="flex elInput code">
            <el-input type="text" autocomplete="off" v-model="user.code" placeholder="验证码"></el-input>
            <div class="flex getCode" @click="reloadCode('vcode-user')" style="cursor: pointer;">
              <img id="vcode-user" src="" alt="">
              <!--								<img src="../assets/img/refresh.png" alt="" width="20" @click="reloadCode('vcode-user')">-->
            </div>
          </div>
          <div class="elInput">
            <el-button v-waves type="primary" @click="onSubmit" :loading="loginBtnLoading">登录</el-button>
          </div>
          <div class="elInput flex select">
            <el-checkbox v-model="user.checked">下次自动登录</el-checkbox>
            <span><router-link to="/forget">忘记密码</router-link>|<router-link
                to="/registered">去注册</router-link></span>
          </div>
        </el-form>
      </div>
    </div>
    <commonRes ref="commonRes"></commonRes>
  </div>
</template>

<script>
import waves from '@/directive/waves'
import SysCons from '@/api/common'
import qs from 'qs';
import commonRes from './famousDoctor/commonRes'

export default {
  name: "login",
  directives: {waves},
  data() {
    return {
      activeName: 'user',
      autoLoginLoading: false,
      user: {
        account: '',
        pwd: '',
        code: '',
        checked: false,
      },
      loginBtnLoading: false,
      r_token: ''
    }
  },
  inject: ['reload'],
  components: {commonRes},
  mounted() {
    // 自动登录
    let that = this;
    if (localStorage.auto_login && localStorage.auto_login == 1) { // 已设置自动登录 尝试登录
      // 验证token有效性测试 , 成功后直接跳往登录页
      this.autoLoginLoading = true;
      // 导航条做了登录判断 直接判断 storage
      if (localStorage.curUid && localStorage.user_type && localStorage.account) {
        if (localStorage.user_type === 'user' || localStorage.user_type == 1) {
          that.$router.push('/index');
          return;
        } else if (localStorage.user_type === 'doctor'||localStorage.user_type == 2) {
          that.$router.push({path: "/workbench/" + localStorage.account});
          return;
        }
      }
      this.$message.info("登录过期");
      this.autoLoginLoading = false;
    }
  },
  methods: {
    onSubmit() {
      let vm = this;
      // 校验信息
      let username = '';
      let password = '';
      let token = '';
      let code = '';
      let userType = 0;
      if (this.activeName == 'user') {
        username = this.user.account;
        password = this.user.pwd;
        token = $('img#vcode-user').attr("key");
        code = this.user.code;

      }
      if ($.trim(username).length === 0) {
        this.$message.warning("用户名不能为空");
        return;
      }
      if ($.trim(password).length === 0) {
        this.$message.warning("密码不能为空");
        return;
      }
      if ($.trim(code).length === 0) {
        this.$message.warning("验证码不能为空");
        return;
      } else if ($.trim(code).length !== 4) {
        this.$message.warning("验证码错误");
        return;
      }
      // 获取token
      let params = {
        grant_type: "password",
        // username: username + "#" + userType,
        username: username + "#0",
        password: password,
        scope: "all",
        token: token,
        code: code,
        client_id: "web",
        client_secret: "secret"
      };
      this.loginBtnLoading = true;
      this.$ajax.post(SysCons.api.login, qs.stringify(params))
          .then((res) => {
            this.loginBtnLoading = false;
            if (res.data && res.data.access_token) {
              localStorage.setItem("access_token", res.data.access_token);
              localStorage.setItem("refresh_token", res.data.refresh_token);
              localStorage.setItem("expires_in", res.data.expires_in);
              localStorage.setItem("get_token_date", new Date().getTime());

              vm.$ajax.post(SysCons.api.current)
                  .then((res) => {
                    if (res.data.status == 'success') {
                      localStorage.setItem("curUid", res.data.data.uid);
                      localStorage.setItem("name", res.data.data.name);
                      localStorage.setItem("headImg", res.data.data.img);
                      localStorage.setItem("account", res.data.data.account);
                      localStorage.setItem("user_type", res.data.data.type);

                      vm.$router.app.$children[0].refreshNav();
                      // 自动登录设置保存
                      if (vm.user.checked) {
                        localStorage.setItem("auto_login", 1);
                      }
                      if(res.data.data.type==2){
                        vm.$router.push({path: "/workbench/" + res.data.data.account});
                      }else{
                        vm.$router.push('/index')
                      }
                    }
                  });
            } else {
              // 登录失败刷新验证码
              if (this.activeName == 'user') {
                this.reloadCode('vcode-user');
              } else {
                this.reloadCode('vcode');
              }

              if (res.data.status === 'fail') {
                //验证码错误
                vm.$message.error(res.data.message);
              } else if (res.data.error) {
                //用户名不存在/密码错误
                vm.$message({
                  type: "error", message: res.data.error_description, onClose: () => {
                  }
                })
              }
            }
          }, (err) => {
            this.loginBtnLoading = false;
            if (this.activeName == 'user') {
              this.reloadCode('vcode-user');
            } else {
              this.reloadCode('vcode');
            }
            console.error('err', err)
          }).catch((err) => {
        this.loginBtnLoading = false;
        if (this.activeName == 'user') {
          this.reloadCode('vcode-user');
        } else {
          this.reloadCode('vcode');
        }
        console.err(err)
        // vm.$message.error(err)
      })
    },
    /*handleClick(tab) {
      if (tab.name == 'first') {
        this.reloadCode('vcode-user');
        this.user = {
          account: '',
          pwd: '',
          code: '',
          checked: false,
        }
      } else {
        this.reloadCode('vcode');
        this.doctor = {
          account: '',
          pwd: '',
          code: '',
          checked: false,
        }
      }
    },*/
    reloadCode(id) {
      this.$ajax.post(SysCons.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          $("img#" + id).attr("src", res.data.data);
          $("img#" + id).attr("key", res.data.token);
        }
      });
    }
  },
  beforeMount() {
    this.reloadCode('vcode-user');
  }
}
</script>


<style scoped lang="scss">
@import '../assets/css/login.scss';

.centerPage {
  height: calc(100vh - 197px);
}
</style>
